import Ajv from "ajv";
import addFormats from 'ajv-formats'
import ajvErrors from 'ajv-errors';
import dayjs from 'dayjs';
import { feedbackCreateSchema } from '@collecting/client';
import {FeedbackModel} from 'model/feedback/FeedbackModels';

const ajv = new Ajv({ allErrors: true, $data: true, strict: false });
addFormats(ajv);
ajvErrors(ajv);

export const nextMonth = dayjs().add(1, 'month');
export const nextYear = dayjs().add(1, 'year');

const collectionValidate = ajv.compile(feedbackCreateSchema);

/* VALIDATION */
export const validate = (data: FeedbackModel, visited: any): Map<string, string> => {
  // dates need to be converted to strings, or have object validation
  // also collectionValidate needs to be called
  let valid = collectionValidate(data);
  let errors = collectionValidate.errors;
  // Reset the violations
  if (!errors) {
    return new Map();
  }
  // we use visited because
  const map = new Map(errors
    .filter((e) => visited.has(e.instancePath))
    .map(toViolation));

  return map;
}

const toViolation = (error: any): [string, string] => {
  return [error.instancePath.replace("/", ""), error.message]
}
